const CarouselFeedSkeleton: React.FC<any> = ({ viewRef }) => {
  return (
    <div className="my-2.5" ref={viewRef}>
      <div className="flex flex-row justify-between items-center mb-2 px-3">
        <div className="bg-surface-200-bg inline-block w-16 h-6 leading-8  rounded-sm skeleton" />
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-20 rounded-700 skeleton" />
      </div>
      <div className="max-w-full overflow-hidden">
        <div className="box-border flex w-[582px] pl-3">
          {new Array(2).fill(0).map((_item, index) => {
            return (
              <div
                className="mr-2.5 last:mr-0 w-[200px] h-[162px] skeleton bg-surface-200-bg rounded-700"
                key={`carousel-feed-skeleton-${index}`}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CarouselFeedSkeleton;
